var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-item',[_c('h4',{staticClass:"color--grey"},[_vm._v("Uitleg")]),_c('p',{staticClass:"color--grey"},[_vm._v("Hier moet de uitleg van dit brand onderdeel ingeladen worden.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }